import { render } from "./InputOnTheJobScore.vue?vue&type=template&id=1fe25e69"
import script from "./InputOnTheJobScore.vue?vue&type=script&lang=ts"
export * from "./InputOnTheJobScore.vue?vue&type=script&lang=ts"
script.render = render

export default script